import { render } from "./Goals.vue?vue&type=template&id=fcec3c3c&scoped=true"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"

import "./Goals.vue?vue&type=style&index=0&id=fcec3c3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcec3c3c"]])

export default __exports__